module.exports = __webpack_public_path__ + "b2226cba1dc11977c270ccd32c6c84d9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/footer/logoCCDV.png
// module id = ./assets/images/footer/logoCCDV.png
// module chunks = 0